import { useState, useContext } from 'react';
import { toast } from 'material-react-toastify';
import { UserContext } from '../context/UserContext';

export const useConsentActions = (authApis, updateLoader, history) => {
	const { clearConsentCache, consentIdList, setConsentIdList } = useContext(UserContext);
	const [revokeSpinner, setRevokeSpinner] = useState(false);

	const selectUnselectAccount = (
		element,
		selectedAccounts,
		setSelectedAccounts
	) => {
		let data = [...selectedAccounts];
		if (
			selectedAccounts
				.map((elm) => elm?.consentIntentId)
				.includes(element?.consentIntentId)
		) {
			let index = data
				.map((elm) => elm.consentIntentId)
				.indexOf(element?.consentIntentId);
			data.splice(index, 1);
		} else {
			data.push(element);
		}
		setSelectedAccounts(data);
	};

	const revokeConsents = async (selectedAccounts, mobileNumber) => {
		setRevokeSpinner(true);
		updateLoader(true);
		// Clear cache since consent state will change
		clearConsentCache();
		let lastIndex = selectedAccounts.length - 1;
		const revokedIds = [];

		for (let i = 0; i < selectedAccounts.length; i++) {
			let consentIntentId = selectedAccounts[i].consentIntentId;
			await authApis.revokeConsent(consentIntentId).then((res) => {
				if (res?.status && res?.status === 'SUCCESS') {
					// Track successfully revoked consent IDs
					revokedIds.push(consentIntentId);
					
					if (consentIntentId === selectedAccounts[lastIndex].consentIntentId) {
						// Remove revoked consent IDs from consentIdList
						const updatedConsentIdList = consentIdList.filter(
							id => !revokedIds.includes(id)
						);
						setConsentIdList(updatedConsentIdList);
						
						updateLoader(false);
						setRevokeSpinner(false);
						history.push({
							pathname: `/status`,
							state: { number: mobileNumber, action : 'Revoked' },
						});
					}
				} else {
					toast.error(res.message);
					updateLoader(false);
					if (res.message === 'Login Required') {
						history.push('/');
					}
					if (i === selectedAccounts.length - 1) {
						setRevokeSpinner(false);
					}
				}
			});
		}
	};

	const resumeConsents = async (selectedAccounts, mobileNumber) => {
		setRevokeSpinner(true);
		updateLoader(true);
		// Clear cache since consent state will change
		clearConsentCache();

		let lastIndex = selectedAccounts.length - 1;

		for (let i = 0; i < selectedAccounts.length; i++) {
			let consentIntentId = selectedAccounts[i].consentIntentId;
			await authApis.resumeConsent(consentIntentId).then((res) => {
				if (res?.status && res?.status === 'SUCCESS') {
					if (consentIntentId === selectedAccounts[lastIndex].consentIntentId) {
						updateLoader(false);
						setRevokeSpinner(false);
						history.push({
							pathname: `/status`,
							state: { number: mobileNumber,action : 'Resumed' },
						});
					}
				} else {
					toast.error(res.message);
					updateLoader(false);
					if (res.message === 'Login Required') {
						history.push('/');
					}
					if (i === selectedAccounts.length - 1) {
						setRevokeSpinner(false);
					}
				}
			});
		}
	};

	const viewConsentDetails = (
		id,
		entityName,
		selectedAccounts,
		mobileNumber,
		consent
	) => {
		updateLoader(true);
		authApis.consentDetails(id).then((res) => {
			if (res?.status && res?.status === 'SUCCESS') {
				getEntityFIPInfo(
					res,
					entityName,
					selectedAccounts,
					mobileNumber,
					consent
				);
			} else {
				updateLoader(false);
				toast.error(res.message);
			}
		});
	};

	const getEntityFIPInfo = async (
		payload,
		entityName,
		selectedAccounts,
		mobileNumber,
		consent
	) => {
		let data = payload;
		for (let i = 0; i < data.Accounts.length; i++) {
			await authApis.entityInfo(data.Accounts[i].fipId, 'FIP').then((res) => {
				data.Accounts[i].entityName = res.entityName;
				if (res?.status && res?.status === 'SUCCESS') {
					if (i === data.Accounts.length - 1) {
						history.push({
							pathname: `/consent-details`,
							state: {
								data: data,
								selectedAccounts: selectedAccounts,
								number: mobileNumber,
								entityName: entityName,
								consent: consent,
							},
						});
						updateLoader(false);
					}
				} else {
					updateLoader(false);
					toast.error(res.message);
				}
			});
		}
	};

	return {
		revokeSpinner,
		selectUnselectAccount,
		revokeConsents,
		viewConsentDetails,
		resumeConsents,
	};
};
